import {FC} from 'react';

import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

const headCells = [
  {
    align: 'left' as const,
    scope: 'row',
    disablePadding: false,
    id: 'author',
    label: 'Пользователь',
  },
  {
    align: 'center' as const,
    disablePadding: false,
    id: 'date',
    label: ' Время',
  },
  {
    disablePadding: false,
    id: 'statusCode',
    label: 'Статус',
    width: 200,
    align: 'center' as const,
  },
];

export const TableHeadContainer: FC = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell width={34} />
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            scope={headCell.scope}
            align={headCell.align || 'center'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            width={headCell.width}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
